<template>
  <div class="the-egame">
    <!-- <div
      class="egame-bg"
      :style="{ background: 'url(' + active.bg + ')' }"
    ></div> -->
    <div class="main tbbg-margin">
      <!-- <div class="notice">
        <Notice :list="noticeList"></Notice>
      </div> -->
      <div class="swiper">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide></swiper-slide>
          <template v-for="(item, index) in casinoMenu">
            <swiper-slide :key="index" v-if="item.nameEn!='fishing'">
            <!-- <div
              :class="{ item: true, active: active.platform == item.platform }"
              :style="{
                background: active.platform == item.platform ? item.color : '',
              }"
              @click="changeActive(item)"
            > -->
              <div
                :class="{ item: true, active: curItem.id == item.id }"
                :style="'background-color:'+(curItem.id == item.id?colorList[index%colorList.length]+';':'')"
                @click="changeActive(item)"
              >
                <img loading="lazy"
                  v-lazy="item.imgUrl"
                  alt=""
                />
                <span class="name">{{ item.name }}</span>
                <span v-if="item.id == '1005'||item.nameEn == 'SEA'" class="fire-icon"></span>
              </div>
            </swiper-slide>
          </template>
          <swiper-slide></swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>

      <div class="tabs">
        <div class="platformIngo">
          <!-- <img loading="lazy" v-lazy="curItem.imgUrl" alt="" /> -->
          <span style="padding-left:20px;">{{ isSearchData ? '全部游戏' : curItem.name }}</span>
        </div>
        <!-- <div class="tab1">
          <ul>
            <li :class="{ active: tab1Active == 0 }" @click="changeTab1(0)">
              全部
            </li>
            <li :class="{ active: tab1Active == 1 }" @click="changeTab1(1)">
              最新上线
            </li>
            <li :class="{ active: tab1Active == 2 }" @click="changeTab1(2)">
              我的收藏 <span class="icon"></span>
            </li>
          </ul>
        </div> -->

        <!-- <div class="tab2">
          <ul>
            <li :class="{ active: tab2Active == 0 }" @click="changeTab2(0)">
              <span class="icon"></span> 图片
            </li>
            <li :class="{ active: tab2Active == 1 }" @click="changeTab2(1)">
              <span class="icon"></span> 列表
            </li>
          </ul>
        </div> -->

        <div class="search">
          <input
            data-v-28f627b1=""
            id="searchstr"
            type="text"
            v-model="searchValue"
            :placeholder="$t('secondGame.input')"
            size="10"
          />

          <input data-v-28f627b1="" id="search_btn" @click="clickToShow(searchValue)" type="button" />
          <div class="searchBox" v-show="searchBoxSwitch && searchList.length" v-loading="searchLoading">
            <div class="item" v-for="(item,index) in searchList" :key="index" @click="clickToShow(item.name)">{{item.name}}</div>
          </div>
        </div>
      </div>

      <div class="res">
        <div class="left">
          <ul class="ul" v-show="gameList.length" v-loading="loading">
            <li class="li" v-for="(item, index) in gameList" :key="index" >
              <div class="img">
                <img loading="lazy" v-lazy="item.pictureUrl?$common.getImgUrl(item.pictureUrl):defaultImg" alt="" @error="defImg()" />
                <div class="cover"></div>
                <div class="btns" @click="getToken(item,1)">
                  <span>
                    <!-- 开始游戏 -->
                    {{$t('indexPage.startGame')}}
                  </span>
                  <!-- <span> -->
                    <!-- 试玩体验 -->
                    <!-- {{$t('indexPage.tryOnce')}}
                  </span> -->
                </div>
                <div v-if="isSearchData" class="search-plat">{{ item.nameEn || item.vendorName }}</div>
                <img v-show="item.status === 0" class="weihu" :src="require('@/assets/images/amjs/weihu.png')" alt="">
              </div>

              <div class="name"><div class="title">{{ item.name }}</div> <!-- <div class="icon"></div> --></div>
            </li>
          </ul>
          <div class="ul" style="display:flex;height:400px;font-size:18px;color:#333;justify-content:center;align-items:center;" v-show="gameList.length == 0">
            暂无数据
          </div>
          <div class="pagi">
              <el-pagination
                  :background="true"
                  layout="prev, pager, next"
                  :page-size="pageInfo.pageSize"
                  :current-page="pageInfo.curPage"
                  :hide-on-single-page="true"
                  @current-change="handleCurrentChange"
                  :total="pageInfo.total">
              </el-pagination>
          </div>
        </div>
        
        <div class="right">
          <div class="win">
            <div class="title"><h2>
              <!-- 最新中奖 -->
              {{$t('secondGame.newReward')}}
            </h2></div>
            <vue-seamless-scroll
              :data="hotMenu"
              style="height:340px;  overflow: hidden;"
              class="scroll"
            >
              <ul class="item">
                <li v-for="(item, index) in hotMenu" :key="index" @click="getToken(item,1)">
                  <img loading="lazy" v-lazy="item.topUrl?$common.getImgUrl(item.topUrl):$common.getImgUrl(item.pictureUrl)" alt="" />
                  <div class="info">
                    <p>{{ item.name }}</p>
                    <p>
                      <!-- 会员 -->
                      {{$t('secondGame.member')}}
                      <span>{{ item.visualName }}</span>
                    </p>
                    <p>
                      <!-- 中奖 -->
                      {{$t('secondGame.reward')}}
                      <span>￥{{ item.visualMoney }}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>

          <div class="hot">
            <div class="title"><h2>
              <!-- 热门推荐 -->
              {{$t('secondGame.hot')}}
            </h2></div>
            <ul class="info">
              <li v-for="(item, index) in recommendMenu" :key="index" v-show="index<5">
                <div class="index">{{ index + 1 }}</div>
                <img loading="lazy" class="img" v-lazy="$common.getImgUrl(item.pictureUrl)" alt="" />
                <div class="name">
                  <p class="gametitle">{{ item.name }}</p>
                  <p>{{ item.vendorName }}</p>
                </div>
                <div class="starWarp">
                  <p class="star" :star="index%1 + 5"></p>
                  <p class="enter" @click="getToken(item,1)">
                    <a href="javascript:;">
                      <!-- 进入游戏 -->
                      {{$t('secondGame.enter')}}
                      </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Notice from "../../components/notice";
import "./index.scss";
export default {
  components: {
    // Notice,
  },
  data() {
    return {
      defaultImg:require('@/assets/images/mb/default-hot.png'),
      searchValue:'',
      searchBoxSwitch:false,
      searchLoading:false,
      swiperOptions: {
        loop: false,
        slidesPerView: 14,
        // spaceBetween: 10,
        // autoplay: {
        //     disableOnInteraction: false,
        // },
        speed: 400,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
      },
      noticeList: [
        {
          title:
            "【辛苦了！内地核酸检测支援队今日离港 大批香港市民到场欢送】内地核酸检测支援队今日(16日)上午陆续乘大巴离港，不少香港市民在支持队下榻酒店外夹道欢送。内地核酸检测支援队共有超过600名队员，在为期14天的香港新冠病毒普及社区检测计划中协助化验检测样本工作。(环球网) ​",
        },
        {
          title:
            "【辛苦了！内地核酸检测支援队今日离港 大批香港市民到场欢送】内地核酸检测支援队今日(16日)上午陆续乘大巴离港，不少香港市民在支持队下榻酒店外夹道欢送。内地核酸检测支援队共有超过600名队员，在为期14天的香港新冠病毒普及社区检测计划中协助化验检测样本工作。(环球网) ​",
        },
      ],
      platformList: [
        {},
        {
          name: "JDB电子",
          icon: "https://tengbo779.com/pcapp/static/img/JDB.b7b4a64.png",
          color: "#4d4d4d",
          platform: "JDB",
          bg: "https://tengbo779.com/pcapp/static/img/JDB.e8a7393.jpg",
          circleIcon: "https://tengbo779.com/pcapp/static/img/JDB.836f9c6.png",
        },
        {
          name: "BBIN电子",
          icon:
            "data:image/png;base64,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",
          color: "#f01924",
          platform: "BBIN电子",
          bg: "https://tengbo779.com/pcapp/static/img/BBIN.19b013b.jpg",
          circleIcon:
            "data:image/png;base64,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",
        },
      ],
      active: {}, //当前平台信息
      tab1Active: 0, //0，全部 1最新上线 2 我的收藏
      tab2Active: 0, //0，图片 1列表
      winData: [
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
        {
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/30bab03d645c4dec9f35f1dad776d528.png",
          name: "精灵宝石",
          member: "张三",
          amount: 99999,
        },
      ], // 中奖列表
      //热门推荐
      hotList: [
        {
          index: 1,
          name: "宝石骑士",
          start: 5,
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/5309efb8f4bf4c479f205432f6f0c536.jpg",
          platform: "AG电子",
        },
        {
          index: 2,
          name: "宝石骑士",
          start: 5,
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/5309efb8f4bf4c479f205432f6f0c536.jpg",
          platform: "AG电子",
        },
        {
          index: 3,
          name: "宝石骑士",
          start: 5,
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/5309efb8f4bf4c479f205432f6f0c536.jpg",
          platform: "AG电子",
        },
        {
          index: 4,
          name: "宝石骑士",
          start: 5,
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/5309efb8f4bf4c479f205432f6f0c536.jpg",
          platform: "AG电子",
        },
        {
          index: 5,
          name: "宝石骑士",
          start: 5,
          icon:
            "https://tbh198.com/resources/tbh/thirdGame/5309efb8f4bf4c479f205432f6f0c536.jpg",
          platform: "AG电子",
        },
      ],
      gameList: [],
      casinoMenu:[],
      curItem:{},
      pageInfo: {
        pid:'', // 父id
        id:'', //子id
        type:'', // 类型
        curPage:1, //当前页
        pageSize:24, // 展示数量
        total:0,//游戏列表总数量
      },
      showSearchSwitch:false,
      loading:false,
      searchList:[], // 搜索栏列表
      isSearchData:false, // 当前是否为搜索数据
      saveSearch:'',
      hotMenu:[], // 热门游戏
      recommendMenu:[], // 推荐游戏
      colorList:['#f01924','#24db3f','#ff7d43','#ffb72e','#256dff','#9d16c9','#ff2965']
    };
  },
  watch:{
    '$route.query.id'(){
      this.getCacheItem();
    },
    searchValue(val){
      if(val.length){
        this.searchBoxSwitch = true;
        if(this.$common.getUser()){
          let data = {
            currentPage:1,
            pageSize:this.pageInfo.pageSize,
            name:val
          }
            this.saveSearch = val;
            this.searchGame(data)
        }else{
            this.$message.warning(this.$t('secondGame.pleaseLogin'))
            this.searchValue = '';
        }
      }else{
        this.searchBoxSwitch = false;
      }
    }
  },
  methods: {
     changeMoney(val){
      let num = null;
      if(val){
        num = Number(val)
      }else{
        num = 0
      }
      let add = Math.floor(Math.random()*99999);
      return add + num;
    },
    changeName(val){
      let arr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
      let name = '***'+arr[Math.floor(Math.random()*arr.length)]+arr[Math.floor(Math.random()*arr.length)]+'***';
      return name
    },
    defImg(){
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    // 输入框搜索列表
    searchGame(data){
        let self = this;
        self.$http.post(self.$api.searchGame,data).then((res,err) => {
            if(err){}else{
                self.searchList = res.data.list;
            }
        });
    },
    // 点击展示列表
    clickToShow(val){
        if(!val){
            this.$message.warning(this.$t('secondGame.nothing'));
            return
        }
        this.pageInfo.curPage = 1;
        let data = {
            currentPage:1,
            pageSize:this.pageInfo.pageSize,
            name:val
        };
        this.saveSearch = val;
        this.gameList = [];
        this.entrySearch(data)
    },
    // 搜索列表返回值展示
    entrySearch(data){
      this.isSearchData = true;
        let self = this;
        self.$http.post(self.$api.searchGame,data).then((res,err) => {
            if(err){}else{
                self.searchValue = '';
                self.showSearchSwitch = true;
                // self.entrySearchList = res.data.list;
                self.gameList = res.data.list;
                self.pageInfo.total = res.data.total;
                // self.hasNextPage = res.data.hasNextPage;
            }
        });
    },
    // 获取数据列表
    getDataType(){
      let result = JSON.parse(localStorage.getItem('game_menus_pc'));
      this.casinoMenu = result.data.dz;
    },

    // 获取缓存当前列表    //切换菜单列表引用
        getCacheItem(){
          let item = JSON.parse(localStorage.getItem('casinoCur'));
          this.curItem = item;
          this.pageInfo.pid = item.parentId;
          this.pageInfo.id = item.ids;
          this.pageInfo.type = item.type;
          this.pageInfo.curPage = 1;
          this.showSearchSwitch = false;
          this.getGameList()
          
        },

    // 切换列表
    chengeItem(val){
          let item = val;
          this.curItem = item;
          this.pageInfo.pid = item.parentId;
          this.pageInfo.id = item.ids;
          this.pageInfo.type = item.type;
          this.pageInfo.curPage = 1;
          this.showSearchSwitch = false;
          this.getGameList()
          
        },

    // 获取游戏列表数据    切换页面直接引用
    getGameList(){
        let self = this;
        let {pid,id,type,curPage,pageSize} = this.pageInfo;
        if(type == 1){
          this.isSearchData = false;
          self.loading = true;
            self.$http.post(self.$api.vendorGame,
                {
                    currentPage: curPage,
                    pageSize: pageSize,
                    gameKindId: pid,
                    vendorId: id,
                }
            ).then((res,err) =>{
                    self.loading = false;
                    self.gameList = res.data.list;
                    self.pageInfo.total = res.data.total;
                });
        }else if(type == 3){
          this.isSearchData = false;
            self.loading = true;
            self.$http.post(
                self.$api.getGameByIds,
                {
                    currentPage: curPage,
                    pageSize: pageSize,
                    gameKindId: pid,
                    ids: id,
                }
            ).then((res,err) =>{
                    self.loading = false;
                    self.gameList = res.data.list;
                    self.pageInfo.total = res.data.total;
                });
        }
    },

     // 进入游戏
        getToken: async function(req,index) {
            let self = this;
                var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                
            if (!self.$common.getUser()) {
                self.$message.warning(self.$t('indexPage.pleaseLogin'))
                return
            }
            self.tenantId = self.$common.getUser().tenant_id
            self.username = self.$common.getUser().username
            self.uid = self.$common.getUser().user_id
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: req.ids || req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            }
            self.$common.setGameRequestData(datas)
            
            const res = await self.$http.post(this.$api.getToken, datas, true)
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                // }else{
                    window.open(self.gameUrl)
                // }
                
                }else{
                    window.open(self.gameUrl)
                }

            } else {
              self.$message.error(self.$t('indexPage.repair'))
                // if (req.openMode === 1) {
                // window.open('/error.html?type=1')
                // // self.winOpen.location.href = '/error.html?type=1';
                // }
                
                // if (req.status === 0) {
                // self.$message.error(self.$t('indexPage.repair'))
                // }else{
                // self.$message.error(self.$t('indexPage.failed'))
                // }
            }
        },

    // 热门游戏
    getHotList(){
        let self = this;
        const visualhotmenu = sessionStorage.getItem('visualhotmenu')
        if (visualhotmenu) {
          self.hotMenu = JSON.parse(visualhotmenu)
          return
        }
        self.$http.get(self.$api.hotGame).then((res,err) => {
        if(err){}else{
          if(res.code == 0){
            self.hotMenu = res.data.map(e => {
              e.visualName = self.changeName()
              e.visualMoney = self.changeMoney()
              return e
            })
            sessionStorage.setItem('visualhotmenu', JSON.stringify(self.hotMenu))
          }
        }
        });
    },

    // 推荐游戏
    getRecommendList(){
        let self = this;
        self.$http.get(self.$api.recommendGame).then((res,err) => {
        if(err){}else{
            if(res.code == 0){
                this.recommendMenu = res.data;
            }
        }
        });
    },

    handleCurrentChange(val){
      this.pageInfo.curPage = val;
      if(this.isSearchData){
          let data = {
              currentPage:this.pageInfo.curPage,
              pageSize:this.pageInfo.pageSize,
              name:this.saveSearch
          };
          this.entrySearch(data)
      }else{
          this.getGameList()
      }
    },
















    //平台切换
    changeActive(item) {
      if (item == this.curItem) {
        return
      }
      this.curItem = item;
      this.chengeItem(item);
    },
    //tab1 切换
    changeTab1(type) {
      this.tab1Active = type;
    },
    //tab2 切换
    changeTab2(type) {
      this.tab2Active = type;
    },
  },
  created() {
    this.active = this.platformList[1];
    this.getDataType(); //获取电子列表
    if(localStorage.getItem('casinoCur')){}else{
      localStorage.setItem('casinoCur',JSON.stringify(this.casinoMenu[0]))
    }
    this.getCacheItem();
    this.getRecommendList(); // 推荐游戏
    this.getHotList(); // 热门游戏
  },
};
</script>

<style scoped>
    .pagi {
        position: absolute;
        right: 20px;
        bottom: 40px;
        height: 50px;
        /* width: 100%; */
        margin: 0 auto;
    }
    .fire-icon {
      position: absolute;
      left: 2px;
      top: 20px;
      display: block;
      width: 40px;
      height: 26px;
      background-image: url('../../assets/images/amjs/fire.gif');
    }
</style>
